import { axiosInstance as axios } from "services";

export const addCartingPersonel = async (body) => {
  const { data } = await axios.post("/supplier/addCartingPersonel", body);
  if (!data.success) throw new Error(data.error || "Failed to add carting personel");
  return data;
};

